import React, {useEffect, useState} from 'react';
import {MembershipPlan} from "types/MembershipPlan";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    membershipPlan: MembershipPlan | null
    show: boolean
    onDelete?: (membershipPlan: MembershipPlan) => any
    onDeleteFail?: (membershipPlan: MembershipPlan, error: unknown) => any
    onCancel?: () => any
}

function DeleteMembershipPlan(props: Props) {
    const {membershipPlan, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(membershipPlan?.name || 'this membership plan');
    const {mutateAsync: deleteMembershipPlan} = useMutation(ngage.membershipPlans.destroy)

    useEffect(() => {
        if(membershipPlan) setName(membershipPlan.name)
    }, [membershipPlan]);

    async function handleDeleteMembershipPlan() {
        if (membershipPlan) {
            try {
                await deleteMembershipPlan(membershipPlan.id)
                await invalidate('membership-plans.all')

                if (onDelete) onDelete(membershipPlan)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(membershipPlan, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Membership Plan"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteMembershipPlan}
            onCancel={handleCancel}
        />
    );
}

export default DeleteMembershipPlan;